import React, { useState } from "react";
import * as S from "./LeadGenForm.styles";
import LeadGenFormLoaderUI from "./LeadGenFormLoaderUI";
import InboundCallWidget from "../InboundCallWidget/InboundCallWidget";

const LeadGenForm = (props) => {
    const destCity = props.destination;
    const srcCity = props.source;
    const {semData = {},startDate='' , showInboundCall = false , contactNumber = ''} = props;
    const { sem_flow = false,utm_medium = '',utm_campaign = ''} = semData;
    const [queryError, setQueryError] = useState({
        "source": {error: false, msg: ""},
        "destination": {error: false, msg: ""},
        "travel_date": {error: false, msg: ""},
        "name": {error: false, msg: ""},
        "mobile": {error: false, msg: ""},
        "email": {error: false, msg: ""},
        "passengers": {error: false, msg: ""},
    });

    const disableBackDates = () => {
        var today, dd, mm, yyyy;
        today = new Date();
        dd = today.getDate();
        mm = today.getMonth()+1;
        yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        return yyyy+"-"+mm+"-"+dd
    }

    const queryFormRegexValidator = ({type, value, required}) => {
        let regex;
        let errMsg;
        let currentDate = new Date().toISOString().slice(0, 10);
        switch (type) {
            case 'source':
                regex = /^[a-zA-Z\, '~!]{3,}$/;
                errMsg = !value ? "Please fill this to proceed." : (value.length < 3 ? "Please type atleast 3 characters" : "Only aphabets are allowed");
                break;
            case 'destination':
                regex = /^[a-zA-Z\, '~!]{3,}$/;
                errMsg = !value ? "Please fill this to proceed." : (value.length < 3 ? "Please type atleast 3 characters" : "Only aphabets are allowed");
                break;
            case 'travel_date':
                regex = /^(20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|1\d|2\d|3[01])$/;
                errMsg = !value ? "Please fill this to proceed." : (new Date().getTime() > new Date(value).getTime() ? "Past date is not allowed" : "Please enter valid date");
                return {
                    isError: regex.test(value) ? (new Date(currentDate).getTime() > new Date(value).getTime() ? true : false) : true,
                    errMsg
                }
            case 'name':
                regex = /^[a-zA-Z '~!]{3,}$/;
                errMsg = !value ? "Please fill this to proceed." : (value.length < 3 ? "Please type atleast 3 characters" : "Only aphabets are allowed");
                break;
            case 'mobile':
                regex = /^\d{10}$/;
                errMsg = !value ? "Please fill this to proceed." : (value.length !== 10 ? "Only 10 digits mobile number is allowed" : "Only numbers are allowed");
                break;
            case 'email':
                regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                errMsg = !value ? "Please fill this to proceed." : "Please enter valid email id";
                break;
            case 'passengers':
                regex = /^\d*[0-9]$/;
                errMsg = !value ? "Please fill this to proceed." : (value<1 ? "Number of passengers couldn't be negative or zero" : "Only numbers are allowed");
                break;
            default:
              return {isError: false, errMsg};
              
        }

        return required ? {isError: !value ? true : !regex.test(value), errMsg} : {isError: false, errMsg : ''}
    }

    const validateFormData = () => {
        let queryDetails = {};
        let newState = {...queryError};

        props.formfields.map((field) => {
            queryDetails[field.name] = document.getElementById(field.id).value;
            const fieldValid = queryFormRegexValidator({ type: field.name, value: queryDetails[field.name], required : field.required });
            newState[field.name] = {error: fieldValid.isError, msg: fieldValid.errMsg}
        })

        if(queryDetails["source"] && queryDetails["destination"] && queryDetails["source"] == queryDetails["destination"]){
            newState["source"] = {error: true, msg: "Please enter different source and destination"};
            newState["destination"] = {error: true, msg: "Please enter different source and destination"};
        }
        const haveError = Object.values(newState).some(item=>{
            return item.error;
        })
        if(haveError){
            setQueryError({
                ...newState
            });
        }else{
            var selectedDate, selectedDD, selectedMM, selectedYYYY;
            selectedDate = queryDetails["travel_date"];
            selectedDate.split("-");
            selectedDD = selectedDate.split("-")[2];
            selectedMM = selectedDate.split("-")[1];
            selectedYYYY = selectedDate.split("-")[0];
            selectedDate = selectedDD+"/"+selectedMM+"/"+selectedYYYY;

            queryDetails["travel_date"] = selectedDate;
            queryDetails["passengers"] = parseInt(queryDetails["passengers"]);
             if(sem_flow){
                queryDetails["utm_medium"] = utm_medium;
                queryDetails["utm_campaign"] = utm_campaign;

             }
            props.submitFormData(queryDetails);
        }
    }

let travelDate =function(){

    if(startDate && startDate.toISOString() && startDate.toISOString().slice(0, 10)){
        return startDate.toISOString().slice(0, 10);
    }
    return new Date().toISOString().slice(0, 10)
}()
    return (
        <S.QueryFormContainer>
            <div className="outer">
                <div className="contactManagementContainer">
                    <div className="contactManagementHdr">
                        <p className="closePopup" onClick={() => props.onClose()}></p>
                        <p className="queryHeading">Send us a query</p>
                    </div>
                    <div className="contactManagementForm">
                        {
                            props.formfields.length ? 
                                <div>
                                    <div>
                                        {   
                                            props.formfields.map((field, index) => {
                                                return(
                                                    <div className="queryFormWrap" key={index}>
                                                        <p className="fontMedium appendBottom10">
                                                            {field.field_text}
                                                            {field.required ? <span className="redText">*</span> : null}
                                                        </p>
                                                        
                                                        <input
                                                            type={field.field_type}
                                                            name={field.name}
                                                            id={field.id}
                                                            className="sendQuery-textInput"
                                                            placeholder={field.place_holder}
                                                            defaultValue={
                                                                field.name==="source" ? srcCity 
                                                                : field.name==="destination" ? destCity 
                                                                : field.name==="travel_date" ? travelDate
                                                                : field.name==="passengers" ? "1" : ""
                                                            }
                                                            min={
                                                                field.name==="travel_date" ? disableBackDates() : (field.name==="passengers" ? "1" : "")
                                                            }
                                                        />
                                                        {queryError?.[field.name]?.error ? <div className="err">{queryError[field.name].msg}</div> : null}
                                                    </div>
                                                )
                                            })
                                        
                                        }
                                    </div>
                                    <p className="form_tnc">
                                        By submitting this form I authorise MakeMyTrip (India) Pvt. Ltd and its affiliates to contact me on my contact number or email.
                                    </p>
                                    <div className="queryFormFooterBtn">
                                        <button
                                            className="primaryBtn fill wdth200"
                                            onClick={() => validateFormData()}
                                        >
                                            Get a callback
                                        </button>
                                    </div>
                                    {showInboundCall ? 
                                    <div className="seperation-section">
                                        <div className="border-seperator"></div>
                                           <p className="or-text">OR</p>
                                        <div className="border-seperator"></div>
                                    </div> : null}
                                    {showInboundCall ? 
                                    <InboundCallWidget 
                                        inboundCallText="Talk to agent (24x7)"
                                        inboundCallNumber={contactNumber}
                                        isForm={true}
                                    /> : null}
                                </div>
                            : <LeadGenFormLoaderUI />
                        }
                    </div>
                </div>
            </div>
        </S.QueryFormContainer>
    )
}

export default LeadGenForm